export default {
	methods: {
		push(path) {
			if (this.$route.path == path) return false
			this.$router.push(path)
		}
	}
}